import '../../css/elements/2fa-input.css';
import { Div } from "../utils/dom";

export class TwoFactorInput extends HTMLElement {
    constructor() {
        super();
        this.inputs = [];
    }

    finish = new Event("finish");

    callback () {
        console.log(":(");
        console.trace();
    }

    connectedCallback() {
        const container = Div();
        this.amount = parseInt(this.getAttribute("length")) || 6;

        for (let x = 0; x < this.amount; x++) {
            let input = document.createElement("input");
            input.inputMode = "numeric";
            input.pattern = "[0-9]*";
            input.type = "text";
            input.maxLength = 1;
            input.classList.add('js-otp-input');
            this.inputs.push(input);
            container.appendChild(input);
            this.registerEvents(x, input);
        }

        this.appendChild(container);
    }

    registerEvents(index, element) {
        element.addEventListener("input", (ev) => this.onInput(index, ev));
        element.addEventListener("paste", (ev) => this.onPaste(index, ev));
        element.addEventListener("keydown", (ev) => this.onKeyDown(index, ev));
    }

    onPaste(index, ev) {
        ev.preventDefault();
        let curIndex = index;
        const clipboardData = ev.clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData("Text");
        for (let i = 0; i < pastedData.length; i++) {
            if (i < this.inputs.length) {
                if (!this.isDigit(pastedData[i])) break;
                this.inputs[curIndex].value = pastedData[i];
                curIndex++;
            }
        }
        if (curIndex === this.inputs.length) {
            this.inputs[curIndex - 1].focus();
            this.callback(this.retrieveOTP());
            this.dispatchEvent(this.finish);
        } else {
            this.inputs[curIndex].focus();
        }
    }

    onKeyDown(index, ev) {
        const key = ev.keyCode || ev.which;
        if (key === 37 && index > 0) { // LEFT_KEY
            ev.preventDefault();
            this.inputs[index - 1].focus();
        }
        if (key === 39 && index + 1 < this.inputs.length) { // RIGHT_KEY
            ev.preventDefault();
            this.inputs[index + 1].focus();
        }
        if (key === 8 && index > 0) { // BACKSPACE_KEY
            if (this.inputs[index].value === "") {
                this.inputs[index - 1].value = "";
                this.inputs[index - 1].focus();
            } else {
                this.inputs[index].value = "";
            }
        }
        if (key === 13) { // ENTER_KEY
            ev.preventDefault();
            if (this.isOTPComplete()) {
                this.callback(this.retrieveOTP());
                this.dispatchEvent(this.finish);
            }
        }
        if (key === 9 && index === this.inputs.length - 1) { // TAB_KEY
            ev.preventDefault();
            if (this.isOTPComplete()) {
                this.callback(this.retrieveOTP());
                this.dispatchEvent(this.finish);
            }
        }
    }

    onInput(index, ev) {
        const value = ev.data || ev.target.value;
        let curIndex = index;
        for (let i = 0; i < value.length; i++) {
            if (i < this.inputs.length) {
                if (!this.isDigit(value[i])) {
                    this.inputs[curIndex].value = "";
                    break;
                }
                this.inputs[curIndex++].value = value[i];
                if (curIndex === this.inputs.length) {
                    if (this.isOTPComplete()) {
                        this.callback(this.retrieveOTP());
                        this.dispatchEvent(this.finish);
                    }
                } else {
                    this.inputs[curIndex].focus();
                }
            }
        }
    }

    select() {
        this.inputs[0].select();
    }
    clear() {
        for(var input of this.inputs) input.value = "";
        this.inputs[0].select();
    }

    retrieveOTP() {
        return this.inputs.map(input => input.value).join('');
    }

    isDigit(d) {
        return d >= '0' && d <= '9';
    }

    isOTPComplete() {
        return this.inputs.every(input => input.value !== '');
    }

    setCallback(callback) {
        console.log("setting callback");
        this.callback = callback;
    }
}

try {
    customElements.define("mfa-input", TwoFactorInput);

} catch {
    // eh.
}
export default { TwoFactorInput };
